const contentfulConfig = {
  space: 'iw9jwdswi70i',
  environment: 'master',
  // accessToken: 'SHNj7vqtSA_d94o_8KCJZVkZDCqIuq22SHN1M5Bvd3U', // sandbox
  accessToken: 'ucXlxvK4lGU2EZxensLftdkMXrI-xpxkSstQ1XBo73Y', // production
};
export default contentfulConfig;
